import { createContext } from "react";

interface CurrentProperties {
  oeeUnitsGood: number;
  oeeUnitsBad: number;
  oeeUnitsTotal: number;
  oeeTimeIdealCycle: number;
  oeeTimeAvailableAll: number;
  oeeTimeOperating: number;
  oeeTimeDown: number;
  timestamp: string;
  quality: number;
  availability: number;
  performance: number;
  oee: number;
}
export interface MachineDataType {
  [key: string]: CurrentProperties;
}

const MachineDataContext = createContext<MachineDataType>({});

export default MachineDataContext;
